import { Loader2Icon } from 'lucide-react';
import { Controller } from 'react-hook-form';
import { toast } from 'sonner';

import { Button } from '../ui/button';
import { Form } from '../ui/form';
import { FieldWrapper } from '../ui/form/field-wrapper';
import { Textarea } from '../ui/textarea';

import {
  updateServiceQuestionInputSchema,
  useUpdateServiceQuestion,
} from '@/features/service-questions/api/edit-question';
import { useQuestion } from '@/features/service-questions/api/get-question';
import { QuestionChoicesEditor } from '@/features/service-questions/components/question-choices-editor';
import { useModalControls } from '@/state/modals';

export const Config = {
  title: 'Modifier la question',
};
export function Component({ qid }: { qid: string }) {
  const { closeModal } = useModalControls();
  const questionQuery = useQuestion({ qid });
  const updateQuestionMutation = useUpdateServiceQuestion({
    qid,
    mutationConfig: {
      onSuccess: () => {
        toast.success('Service modifié');
        closeModal();
      },
      onError: (error) => {
        toast.error('Erreur lors de la modification du service');
        console.error(error);
      },
    },
  });

  if (questionQuery.isPending) {
    return <Loader2Icon className="h-6 w-6 animate-spin" />;
  }

  const question = questionQuery.data;

  if (!question) return null;

  return (
    <div className="space-y-4">
      <Form
        id="edit-question"
        onSubmit={(values) => {
          updateQuestionMutation.mutate({ qid, values });
        }}
        schema={updateServiceQuestionInputSchema}
        options={{
          defaultValues: {
            text: question.text,
            type: question.type!,
            choices: question.choices,
          },
        }}
      >
        {({ register, formState, control, watch }) => {
          const isTypeOpen = watch('type') === 'open';

          return (
            <div className="grid gap-4">
              <FieldWrapper label="Texte" error={formState.errors['text']}>
                <Textarea {...register('text')} />
              </FieldWrapper>
              {!isTypeOpen && (
                <FieldWrapper label="Choix">
                  <Controller
                    name="choices"
                    control={control}
                    render={({ field }) => (
                      <QuestionChoicesEditor
                        choices={field.value}
                        onChoicesChange={field.onChange}
                      />
                    )}
                  />
                </FieldWrapper>
              )}
            </div>
          );
        }}
      </Form>
      <div className="flex justify-end gap-2">
        <Button variant={'secondary'} size="sm" onClick={closeModal}>
          Annuler
        </Button>
        <Button
          form="edit-question"
          type="submit"
          size="sm"
          isLoading={updateQuestionMutation.isPending}
        >
          Enregister
        </Button>
      </div>
    </div>
  );
}
